export const slugifySegment = (value?: string | null): string => {
  if (!value) return '';

  return (
    value
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\u0600-\u06FFa-zA-Z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || value.trim()
  );
};

export const getEntitySlug = (entity?: {
  slug?: string | null;
  name?: string | null;
  code?: string | number | null;
}): string => {
  if (!entity) return '';
  if (entity.slug) return slugifySegment(entity.slug);
  if (entity.name) return slugifySegment(entity.name);
  if (entity.code != null) return slugifySegment(String(entity.code));
  return '';
};
